import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { RadioButton } from "primereact/radiobutton";
// import { handlePostRequest } from "../../../services/PostTemplate";
// import { handlePutRequest } from "../../../services/PutTemplate";
import { Button } from "primereact/button";
import { handlePostRequest } from "../../services/PostTemplate";

const DialogPin = ({ onHide, loadingSecurityPin, clearForm, setloadingSecurityPin }) => {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");

    const cancelHandler = (e) => {
        e.preventDefault();
        onHide();
    };

    const formik = useFormik({
        initialValues: {
            radioButton: "",
        },
        validate: (data) => {
            let errors = {};

            if (!data.radioButton) {
                errors.radioButton = "This field is required.";
            }
            return errors;
        },
        onSubmit: async (data) => {
            setloading(true);
            setloadingIcon("pi pi-spin pi-spinner");
            console.log(data);
            await handlePostRequest(data, "zbizgateway/nonFin/generateCompanyOtp");
            onHide();
            setloading(false);
            setloadingIcon("pi pi-save");
            formik.resetForm();
            clearForm();
            setloadingSecurityPin(true);
        },
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <div className="card Card__Round">
                <div className="Dialog__Round">
                    <div className="Form__Header">
                        <h1>Set Password For</h1>
                    </div>
                    <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                        {loadingSecurityPin ? (
                            <div className="Radio__Btn">
                                <div className="p-field-radiobutton">
                                    <RadioButton inputId="radioButton" name="radioButton" value={"E"} onChange={formik.handleChange} checked={formik.values.radioButton === "expirenow"} />
                                    <label htmlFor="radioButton">Expire Now</label>
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className="Radio__Btn">
                                    <div className="p-field-radiobutton">
                                        <RadioButton inputId="radioButton" name="radioButton" value={"H"} onChange={formik.handleChange} checked={formik.values.radioButton === "H"} />
                                        <label htmlFor="radioButton">One hours</label>
                                    </div>
                                </div>
                                <div className="Radio__Btn">
                                    <div className="p-field-radiobutton">
                                        <RadioButton inputId="radioButton" name="radioButton" value={"D"} onChange={formik.handleChange} checked={formik.values.radioButton === "D"} />
                                        <label htmlFor="radioButton">One Day</label>
                                    </div>
                                </div>
                                <div className="Radio__Btn">
                                    <div className="p-field-radiobutton">
                                        <RadioButton inputId="radioButton" name="radioButton" value={"W"} onChange={formik.handleChange} checked={formik.values.radioButton === "W"} />
                                        <label htmlFor="radioButton">One Week</label>
                                    </div>
                                </div>
                                <div className="Radio__Btn">
                                    <div className="p-field-radiobutton">
                                        <RadioButton inputId="radioButton" name="radioButton" value={"M"} onChange={formik.handleChange} checked={formik.values.radioButton === "M"} />
                                        <label htmlFor="radioButton">One Month</label>
                                    </div>
                                </div>
                            </>
                        )}

                        <div className="Dialog__DownBtn">
                            <Button label="Cancel" className="DialogBtn__Transparent" onClick={(e) => cancelHandler(e)} />
                            <Button disabled={loading} label="Done" className="DialogBtn__Dark" />
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default DialogPin;
